import { z } from "zod";
import { DATA_TYPES_FOR_DATA_EXTRACTION } from "@/isomorphic/constants/workflow-phase-consts";

// ============================================================================
// TRIGGERED CONDITION SCHEMA
// ============================================================================

// Represents a condition that triggered an alert with actual values
export const TriggeredConditionSchema = z.object({
  dataReferenceId: z.string(),
  dataReferenceType: z.enum(DATA_TYPES_FOR_DATA_EXTRACTION),
  values: z.array(z.union([z.string(), z.number()])),
  frequencyCount: z.number().optional(),
  frequencyTimeWindow: z.number().optional(), // in hours
});

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type TriggeredCondition = z.infer<typeof TriggeredConditionSchema>;
